module.exports = __webpack_public_path__ + "static/media/img17.d7261f19.JPG";